import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Grid, TextField, Button,
  Card, CardContent, CardActions, Switch, IconButton
} from '@mui/material';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const GalleryManager = () => {
  const [gallery, setGallery] = useState([]);
  const [title, setTitle] = useState('');
  const [newImage, setNewImage] = useState('');
  const [preview, setPreview] = useState('');
  const [isActive, setIsActive] = useState(true);
  const token = localStorage.getItem('token');

  const apiBase = process.env.REACT_APP_API_BASE_URL;

  const fetchGallery = () => {
    axios.get(`${apiBase}/api/admin/gallery`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => setGallery(res.data))
      .catch((err) => console.error('Fetch error:', err));
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setNewImage(reader.result);
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleAddImage = async () => {
    if (!title || !newImage) {
      alert('Title and image are required.');
      return;
    }

    try {
      await axios.post(`${apiBase}/api/admin/gallery`, {
        title,
        image: newImage,
        active: isActive,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('Image added to gallery');
      setTitle('');
      setNewImage('');
      setPreview('');
      setIsActive(true);
      fetchGallery();
    } catch (err) {
      console.error('Post failed:', err);
      alert('Failed to add image');
    }
  };

  const handleDelete = (id) => {
    axios.delete(`${apiBase}/api/admin/gallery/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(fetchGallery)
      .catch((err) => console.error('Delete error:', err));
  };

  const toggleActive = (id, currentStatus) => {
    axios.put(`${apiBase}/api/admin/gallery/${id}`, {
        active: !currentStatus,
    }, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(fetchGallery)
      .catch((err) => console.error('Toggle active error:', err));
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>Gallery Manager</Typography>

      <Box display="flex" alignItems="center" gap={2} mb={3} flexWrap="wrap">
        <TextField
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          size="small"
        />
        <Button
          variant="contained"
          component="label"
          startIcon={<CloudUploadIcon />}
        >
          Upload Image
          <input type="file" hidden accept="image/*" onChange={handleFileChange} />
        </Button>
        <Typography>Active:</Typography>
        <Switch
          checked={isActive}
          onChange={() => setIsActive(!isActive)}
          color="primary"
        />
        <Button onClick={handleAddImage} variant="contained" color="primary">
          Add to Gallery
        </Button>
      </Box>

      {preview && (
        <Box mb={3}>
          <Typography variant="body2">Preview:</Typography>
          <img src={preview} alt="Preview" style={{ maxHeight: 100 }} />
        </Box>
      )}

      <Grid container spacing={2}>
        {gallery.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <Card>
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold">
                  {item.title || 'Untitled'}
                </Typography>
                {item.image && (
                  <Box mt={1}>
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{ maxWidth: '100%', maxHeight: 120 }}
                    />
                  </Box>
                )}
                <Typography variant="body2" mt={1}>
                  Created by: {item.created_by} <br />
                  Modified: {new Date(item.modified_date).toLocaleString()}
                </Typography>
              </CardContent>
              <CardActions>
                <Switch
                  checked={item.active}
                  onChange={() => toggleActive(item.id, item.active)}
                  color="primary"
                />
                <IconButton color="error" onClick={() => handleDelete(item.id)}>
                  <DeleteIcon />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default GalleryManager;
